import { GetDaDataSuggestRequest, GetDaDataSuggestResponse } from "./types";


const dadataApiUrl = import.meta.env.VITE_DADATA_API_URL as string;

export const getDaDataSuggestParty = async (
  request: GetDaDataSuggestRequest,
): Promise<GetDaDataSuggestResponse> => {
  const options: RequestInit = {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(request),
  };
  const response = await fetch(`${dadataApiUrl}/party`, options);
  return response.json();
};
